import cn from 'classnames'
import { ReactNode, useCallback } from 'react'

import IconLoader from 'images/icon-loader-blue.svg'

import styles from './styles.module.scss'

export default function ButtonWhite({
  className,
  disabled = false,
  isLoading = false,
  disableHover = false,
  onClick = null,
  children,
  icon,
  iconStyles,
  ...props
}: {
  className?: string
  disabled?: boolean
  isLoading?: boolean
  disableHover?: boolean
  onClick?: () => void
  children?: ReactNode
  icon?: string
  iconStyles?: string
}) {
  const handleClick = useCallback(() => {
    if (isLoading) return
    onClick?.()
  }, [onClick])

  return (
    <button
      className={cn(
        styles.button,
        {
          [styles.hover]: !disableHover && !isLoading,
          [styles.disabled]: disabled,
          [styles.isLoading]: isLoading,
        },
        className,
      )}
      type="button"
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {icon && <img src={icon} alt="button icon" className={cn(styles.button__icon, iconStyles)} />}
      {!isLoading && children}
      {isLoading && <img src={IconLoader} alt="Loading" className={styles.button__iconLoader} />}
    </button>
  )
}
